import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ch-report-listing',
  templateUrl: './report-listing.component.html',
  styleUrls: ['./report-listing.component.css'],
})
export class ReportListingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/reports/report-listing/report-listing.component.ts